// extracted by mini-css-extract-plugin
module.exports = {"wrapperFooter":"Footer_wrapperFooter__E6ovu"};